import { formatDateLong } from "../../helperfunctions/helperfunctions";
import '../../css/adminStyling.css';

const AdminActiviteit = (props) => {

    const { activiteit, selectedActiviteit, setSelectedActiviteit } = props;
    const { _id, naam, datum } = activiteit;
    const formatDatum = formatDateLong(datum);
    
    const handleInfoClick = () => {
        setSelectedActiviteit(_id);
    }



    return (
        <>
            <tr className= {selectedActiviteit === _id ? "active" : ""}>
                <td>{formatDatum}</td>
                <td>{naam}</td>
                <td><button onClick={handleInfoClick}>Info</button></td>
            </tr>

        </>
    );
}

export default AdminActiviteit;